import React from 'react';

const Preloader = () => {
  return (
    <div className="preloader">
      <div className="loader"></div>
    </div>
  );
};

export default Preloader;